import {Form} from "../../../../../utils/Form";
import {
    SaveProvisionedDeviceMutation,
    SaveProvisionedDeviceMutationVariables,
    useSaveProvisionedDeviceMutation,
} from "../../queries.generated";
import {DataSource} from "./DataSource";

export const DEFAULT_VARIANT_NAME = "";

export const createInitialData = (dataSource: DataSource): SaveProvisionedDeviceMutationVariables => {
    if (dataSource.state !== "ok") {
        return {
            id: undefined,
            userId: undefined,
            macAddress: "",
            vendorId: 0,
            variant: "",
            provisioning: false,
            useDisplayNameForStationName: false,
        };
    }

    return {
        // it will be either of them
        id: dataSource.device?.id,
        userId: dataSource.userId,

        macAddress: dataSource.device?.macAddress || "",
        vendorId: dataSource.device?.vendor.id || dataSource.domainAdminData.domainDefaults.vendor.id,
        variant:
            dataSource.device?.variant ||
            dataSource.domainAdminData.domainDefaults.deviceVariant?.name ||
            DEFAULT_VARIANT_NAME,
        provisioning: dataSource.device?.provisioning ?? false,
        useDisplayNameForStationName: dataSource.device?.useDisplayNameForStationName ?? false,
    };
};

export default class ProvisionedForm extends Form<
    SaveProvisionedDeviceMutation,
    SaveProvisionedDeviceMutationVariables
> {
    constructor(initialData: SaveProvisionedDeviceMutationVariables, cacheKeyPostfix: string) {
        super("saveProvisionedDevice");
        this.hooks(useSaveProvisionedDeviceMutation, initialData, undefined, undefined, cacheKeyPostfix);
    }
}
